import { render, staticRenderFns } from "./DeviceWikiDrawer.vue?vue&type=template&id=62587b58&scoped=true&"
import script from "./DeviceWikiDrawer.vue?vue&type=script&lang=js&"
export * from "./DeviceWikiDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DeviceWikiDrawer.vue?vue&type=style&index=0&id=62587b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62587b58",
  null
  
)

export default component.exports